import React, { useState } from 'react'
import hopper from '../../assets/hopper.webp'
import hopper2 from '../../assets/thumbnail_hopper final.png'
import "./headerXLarge.css"
import "./header.css"
import "./headerMedium.css"
import "./headerSmall.css"
import "./headerXSmall.css"



const Header = () => {
   //ON SCROLL NAVBAR
   const [textIsScroll, setTextIsScroll] = useState(true)
window.addEventListener('scroll', () => {
    // ONSCROLL TITLE
    if (window.scrollY > 500) {
        setTextIsScroll(false)
    } else if (window.scrollY <= 500) {
        setTextIsScroll(true)
    }
}); 

const [hopperDisappear, setHopperDisappear] = useState(true)
window.addEventListener('scroll', () => {
    // ONSCROLL TITLE
    if (window.scrollY > 600 ) {
        setHopperDisappear(false)
    } else if (window.scrollY <= 600) {
        setHopperDisappear(true)
    }
});

const [Scroll, setScroll] = useState(true)
window.addEventListener('scroll', () => {
    if (window.scrollY > 600) {
        setScroll(false)
    } else if (window.scrollY <= 600) {
        setScroll(true)
    }
}); 


  return (
    <div className='hero-wrapper'>
        <img src={hopper} id="hopper" className="parallaxImg"  loading="lazy" alt="Nighthawks by Edward Hoper"/>
    <section className={`${Scroll ? 'parallax' : "dark_background parallax" }`} id='hero'>
    <div className='darkShadow'></div>
        
        <div id="text" className={`${textIsScroll ? 'show' : "" }`} >
            <div>
            <h2 className="title tracking-in-expand">LUCA</h2>
            <h3 className="subtitle tracking-in-expand-sub">FRONT-END DEVELOPER</h3>
            </div>
            <div className='button-wrapper'>
            <a href='#work'><button className='main-button slide-in-bottom-first header-btn'>Projects</button></a>
            <a href='#about'><button className='main-button slide-in-bottom-second header-btn' >About</button></a>
            <a href='#contact'><button className='main-button slide-in-bottom-third header-btn' >Contact</button></a>
            </div>
        </div>
        <div className='scroll-indicator'>
            <div className='bounce'></div>
        </div>
        <img src={hopper2} className={`${hopperDisappear ? 'parallaxImg' : "zeroOpacity parallaxImg" }`} id="hopper2"  loading="lazy" alt="Nighthawks by Edward Hoper"/>
    </section>
    </div>
  )
}

export default Header